import { AxiosInstance } from "axios";
import { action, IAction } from "mobx";
import Resource from "./Resource";

export default class TriggerStore {
  url: string;
  client: AxiosInstance;
  loadTrigger: (() => Promise<Resource[]>) & IAction;
  loadPopupTrigger: (() => Promise<Resource[]>) & IAction;

  constructor(url: string, client: AxiosInstance) {
    this.url = url;
    this.client = client;

    this.loadTrigger = action(() => {
      return this.client.get(this.url).then((response) => {
        return response.data;
      });
    });

    this.loadPopupTrigger = action(() => {
      return this.client.get("api/profile/popup-trigger/").then((response) => {
        return response.data;
      });
    });
  }
}
